import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logPageView } from '../../services/google-analytics'; // Import GA logging function

const PageTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
      logPageView(location.pathname + location.search); // Log route change
    }
  }, [location]);

  return null; // This component doesn't render anything
};

export default PageTracker;
